import request from "@/utils/request";
import Cookies from "js-cookie";

// h5页面-用户未登录获取课程详情
export function getAppLiveInfo(data) {
  return request({
    url: `/app/zhkt/live/v1/query/mobile/info?id=${data.id}&schoolId=${data.schoolId}&type=${data.type}`,
    method: "get",
  });
}

// h5页面-获取直播流地址
export function getStreamLive(liveId, schoolId) {
  return request({
    url: `/app/zhkt/live/v1/mobile/get/live/stream?liveId=${liveId}&schoolId=${schoolId}`,
    method: "get",
  });
}

// h5页面-获取直播回放列表
export function getPlaybackInfo(liveId, schoolId) {
  return request({
    url: `/app/zhkt/live/v1/mobile/get/playback/info?liveId=${liveId}&schoolId=${schoolId}`,
    method: "get",
  });
}

// h5页面-获取摄像机直播回放
export function getCameraPlaybackInfo(liveId, schoolId) {
  return request({
    url: `/app/zhkt/live/v1/mobile/get/camera/playback/info?liveId=${liveId}&schoolId=${schoolId}`,
    method: "get",
  });
}

// h5页面-获取系列课程视频详情
export function getAppCourseVideo(data) {
  return request({
    url: `/app/zhkt/series/courseware/v1/hero/mobile/get/course/video?id=${data.id}&schoolId=${data.schoolId}&type=${data.type}`,
    method: "get",
  });
}

// 通过id查询评课课例表
export function getAppInfoById(data) {
  return request({
    url: `/app/sgktteachingresearchevaluation/v1/hero/getInfoById?evCourseId=${data.id}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// 获取直播流地址（互动教研）
export function getAppLiveStream(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/hero/mobile/get/live/stream?id=${data.id}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// 获取直播流地址（远程互动）
export function getAppLiveStreamYCHD(data) {
  return request({
    url: `/app/zhkt/deliver/class/v1/hero/mobile/get/live/stream?id=${data.id}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// h5页面-获取直播流地址（教研直播）
export function getAppLiveStreamJYZB(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/hero/mobile/get/live/stream?id=${data.id}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// 获取视频回放地址（互动教研）
export function getAppVideoStream(data) {
  return request({
    url: `/app/zhkt/teaching/research/interaction/v1/hero/mobile/hero/getVideoUrl?id=${data.id}&schoolId=${data.schoolId}`,
    method: "get",
  });
}

// 获取视频回放地址（教研直播）
export function getAppVideoStreamJYZB(data) {
  return request({
    url: `/app/zhkt/teaching/research/live/v1/hero/mobile/hero/getVideoUrl?id=${data.id}&schoolId=${data.schoolId}&type=${data.type}`,
    method: "get",
  });
}

// 获取视频地址（远程互动）
export function getAppVideoStreamYCHD(data) {
  return request({
    url: `/app/zhkt/deliver/class/v1/hero/mobile/hero/getVideoUrl?id=${data.id}&schoolId=${data.schoolId}`,
    method: "post",
  });
}

// h5页面-获取用户收藏状态
export function getAppQueryBehavior(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/app/zhkt/business/user/v1/mobile/query/behavior?businessId=${data.id}&businessType=${data.type}`,
    method: "get",
  });
}

// h5页面-保存用户行为
export function getAppSaveBehavior(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: "/app/zhkt/business/user/v1/mobile/save/behavior",
    method: "post",
    data: data,
  });
}

// 加入聊天室
export function joinGroup(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/base/baseImGroup/v1/joinGroup`,
    method: "post",
    data: data,
  });
}

// 查询聊天记录
export function getPageMessageInfo(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/base/baseImGroup/v1/pageMessageInfo`,
    method: "post",
    data: data,
  });
}

// 保存用户评论
export function appSaveCommon(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/app/zhkt/playback/common/v1/app/save/common`,
    method: "post",
    data: data,
  });
}

// 查询用户评论
export function appQueryCommon(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/app/zhkt/playback/common/v1/app/query/common`,
    method: "get",
    params: data,
  });
}

// 删除用户评论
export function appDeleteCommon(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/app/zhkt/playback/common/v1/app/delete/common`,
    method: "get",
    params: data,
  });
}

// h5页面-判断用户是否有业务观看权限
export function getUserViewBusiness(data) {
  return request({
    headers: { Authorization: Cookies.get("tokenValue") },
    url: `/app/zhkt/live/v1/check/user/view/business`,
    method: "get",
    params: data,
  });
}
